<template>
  <aside class="role-info_cont info-right-cont">
    <header class="info-header info-header_column">
      <h1 class="role-name big-title">
        <trim-item class="info-header-cut" :string="name" :width="1"></trim-item>
      </h1>
      <p class="description">
        {{desc}}
      </p>
    </header>
    <section-toggler @toggle="toggleSec($event)"
                     class="section-toggler"
                     :tabs="createReactLangSections"></section-toggler>
    <component :is="activeSection"
               :name="name"
               :tags="tags"
               v-if="activeRole"
               @reload="$emit('reload')"
               :desc="desc" ></component>
    <section class="role-permissions"
             v-else-if="activeRole && !active">

    </section>
    <footer class="info-footer" v-if="activeRole">
      <div class="hint-cont">
        <button type="button"
                @click="checkDel"
                class="control-btn-new hover-blue-new hint-cont">
          <del-icon></del-icon>
        </button>
        <p class="btn-hint btn-hint_bottom btn-hint_small">
          {{$t('btns.users.delUser')}}
        </p>
      </div>
    </footer>
  </aside>
</template>

<script>
  import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import delIcon from '../../Svg/cart_control/delIcon'
  import roleInfoData from './roleInfoInfo'
  import roleInfoPermissions from './roleInfoPermissions'
  import {sectionsToggler} from "../../../mixins/utils/sectionToggler";
  import {delItem} from "../../../mixins/delItem";
  import {toFormData} from "../../../mixins/utils/toFormData";
  import trimItem from '../../trimITem'
  import {showOverlay} from "../../../mixins/utils/showOverlay";

  export default {
    name: 'roleInfo',
    mixins: [tokenAndRoute, sectionsToggler, delItem, toFormData, showOverlay],
    components: {
      delIcon,
      roleInfoData,
      roleInfoPermissions,
      trimItem
    },
    data() {
      return {
        name: '',
        desc: '',
        tags: [],
        id: '',
        parent_id: '',
        date: '',
        loading: false,
        active: true,
        activeSection: roleInfoData,
        sections: []
      }
    },
    computed: {
      ...mapState({
        confirmUnset: state => state.popups.del.confirmUnset
      }),
      ...mapGetters({
        activeRole: 'roles/activeRole'
      }),
      createReactLangSections() {
        return this.sections = [
          {
            id: 0,
            name: this.$t('roles.rolesTabs.general'),
            component: roleInfoData,
            active: true
          },
          {
            id: 1,
            name: this.$t('roles.rolesTabs.permissions'),
            component: roleInfoPermissions,
            active: false
          }
        ]
      },
    },
    watch: {
      activeRole(val) {
        if(val) {
          this.name = val.name;
          this.desc = val.description;
          this.id = val.id;
          this.parent_id = val.parent
          this.tags = val.tags
        }
      },
      confirmUnset(val) {
        if (val) {
          this.removeFromGroup();
        }
      }
    },
    methods: {
      ...mapActions({
        updateRole: 'roles/updateRole',
        deleteRole: 'roles/deleteRole'
      }),
      ...mapMutations({
        setAddRoleInGroupToggle: 'popups/addRoleInGroup/SET_SHOW',
        setRolesList: 'popups/addRoleInGroup/SET_ROLES',
        showUnsetGroup: 'popups/del/SET_SHOW_UNSET',
        setConfirmName: 'popups/del/SET_ITEMS'
      }),
      checkDel() {
        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(this.name)
      },
      deleteItems() {
        this.delRole();
      },
      async delRole() {
        await this.deleteRole({token: this.token, id: this.activeRole.id}).then(() => {
          this.$router.push('/roles')

        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.role-info_cont {
  height: calc(100vh - 120px - 30px);
  top: 120px
}

.info-footer {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

  .btn-transparent_blue {
    width: 200px;
    height: 40px;
  }

  .section-toggler {
    margin-bottom: 0;
  }

  .role-name {
    width: 100%;
    font-size: 18px;
  }
</style>
<style lang="scss">
  .big-title .info-header-cut .trim-text {
    height: 20px !important;
  }
  .vs__selected {
    &:hover {
      .vs__deselect {
        position: absolute !important;
        background-color: white;
      }
      color: white !important;
    }
  }
</style>
